export const API_PROJECTS_RESULTS_SECTION_FIELDS = [
    'project_first_type.results_impacts_section.id',
    'project_first_type.results_impacts_section.status',
    'project_first_type.results_impacts_section.sort',
    'project_first_type.results_impacts_section.metrics',
    'project_first_type.results_impacts_section.translations'
];
